import { render, staticRenderFns } from "./carImg.vue?vue&type=template&id=188a6bb1&scoped=true&"
import script from "./carImg.vue?vue&type=script&lang=js&"
export * from "./carImg.vue?vue&type=script&lang=js&"
import style0 from "./carImg.vue?vue&type=style&index=0&id=188a6bb1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188a6bb1",
  null
  
)

export default component.exports